import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import router from '../router'
import axios from 'axios'; // Importar axios

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    username: '',
    rol: '',
    nivel: '',
    auth: '',
    id: null,
    menuItems: [],
    paises: [],
    centros: [],
    campanas: [],
    segmentos: [],
    centrosAsignados: [],
    campanasAsignadas: []
  },
  getters: {
    getMenuItems: state => state.menuItems,
    getPaises: (state) => state.paises,
    getCentros: (state) => state.centros,
    getRol: (state) => state.rol,
    getNivel: (state) => state.nivel,
    getSegmentos: (state) => state.segmentos,
    getCampanas: (state) => state.campanas,
    getCentrosAsignados: state => state.centrosAsignados,
    getCampanasAsignadas: state => state.campanasAsignadas
  },
  mutations: {
    setPaises(state, paises) {
      state.paises = paises;
    },
    setCentros(state, centros) {
      state.centros = centros;
    },
    setSegmentos(state, segmentos) {
      state.segmentos = segmentos;
    },
    setCampanas(state, campanas) {
      state.campanas = campanas;
    },
    setCentrosAsignados(state, centros) {
      state.centrosAsignados = centros;
    },
    setCampanasAsignadas(state, campanas) {
      state.campanasAsignadas = campanas;
    },
    setUsername(state, username) {
      state.username = username;
      //state.auth = true;
    },
    setAuth(state, auth) {
      state.auth = auth;
    },
    setRole(state, rol) {
      state.rol = rol;
    },
    setNivel(state, nivel) {
      state.nivel = nivel;
    },
    setId(state, id) {
      state.id = id;
    },
    logout(state) {
      localStorage.removeItem('token')
      sessionStorage.removeItem('token')
      state.username = '';
      state.auth = false;
      state.rol = '';
      state.nivel = '';
      router.push({ 'path': '/' })
    },
    setMenuItems(state, items) {
      state.menuItems = items;
    }
  },
  actions: {
    updateMenuItems({ commit }, items) {
      commit('setMenuItems', items);
    },
    async fetchCountry({ commit }) {
      try {
        const response = await axios.get('getCountry');
        commit('setPaises', response.data);
      } catch (error) {
        console.error('Error al obtener los países:', error);
      }
    },
    async fetchCenter({ commit }) {
      try {
        const response = await axios.get('getCenter');
        commit('setCentros', response.data);
      } catch (error) {
        console.error('Error al obtener los centros:', error);
      }
    },
    async fetchCampaign({ commit }) {
      try {
        const response = await axios.get('getCampaign');
        commit('setCampanas', response.data);
      } catch (error) {
        console.error('Error al obtener las campañas:', error);
      }
    },
    async fectSegment({ commit }) {
      try {
        const response = await axios.get('getSegment');
        commit('setSegmentos', response.data);
      } catch (error) {
        console.log('Error al obtener los segmentos:', error)
      }
    },
    async fectMenu({ commit }) {
      try {
        const response = await axios.post('menu', { 'rol': this.state.rol });
        commit('setMenuItems', response.data);
      } catch (error) {
        console.log('Error al obtener los segmentos:', error)
      }
    }
  },
  modules: {
  },
  plugins: [
    createPersistedState()
  ]
})
